/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../ui_elements/ui_element';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "AdditionalCardScreenConfigs": {
                    "fields": {
                      "nextButtonLabel": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "manualEntryLabel": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "candidates": {
                        "type": ".squareup.bbfrontend.service.v1.CardAssignmentCandidate",
                        "id": 4,
                        "rule": "repeated"
                      },
                      "submission": {
                        "type": ".squareup.bbfrontend.service.v1.AdditionalCardScreenConfigs.Submission",
                        "id": 5,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Submission": {
                        "fields": {
                          "selectedCandidate": {
                            "type": ".squareup.bbfrontend.service.v1.CardAssignmentCandidate",
                            "id": 1,
                            "rule": "optional"
                          },
                          "loadingElement": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.LoadingElement",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "CardAssignmentCandidate": {
                    "fields": {
                      "owner": {
                        "type": ".squareup.bbfrontend.service.v1.CardAssignmentCandidate.Owner",
                        "id": 1
                      },
                      "manualEntry": {
                        "type": ".squareup.bbfrontend.service.v1.CardAssignmentCandidate.ManualEntry",
                        "id": 2
                      }
                    },
                    "nested": {
                      "Owner": {
                        "fields": {
                          "fullName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "token": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "profileImage": {
                            "type": ".squareup.bbfrontend.service.v1.CardAssignmentCandidate.ProfileImage",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "ManualEntry": {
                        "fields": {
                          "firstName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "lastName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "email": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "ProfileImage": {
                        "fields": {
                          "remoteUrl": {
                            "type": "string",
                            "id": 1
                          },
                          "initialsAvatar": {
                            "type": ".squareup.bbfrontend.service.v1.CardAssignmentCandidate.InitialsAvatar",
                            "id": 2
                          }
                        },
                        "nested": {
                          "image": {
                            "oneof": ["remoteUrl", "initialsAvatar"]
                          }
                        }
                      },
                      "InitialsAvatar": {
                        "fields": {
                          "initials": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "backgroundColor": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "initialsColor": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "candidate": {
                        "oneof": ["owner", "manualEntry"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.AdditionalCardScreenConfigs && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.AdditionalCardScreenConfigs?.nested?.Submission && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CardAssignmentCandidate && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CardAssignmentCandidate?.nested?.Owner && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CardAssignmentCandidate?.nested?.ManualEntry && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CardAssignmentCandidate?.nested?.ProfileImage && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CardAssignmentCandidate?.nested?.InitialsAvatar) {
  $root.addJSON(jsonData);
}

/**
 * Mobile response for the first screen.
 *
 * SOURCE AdditionalCardScreenConfigs @ squareup/bbfrontend/common/workflow/screens/additional_card.proto at 15:1
 */
export const AdditionalCardScreenConfigs = $root.lookupType('squareup.bbfrontend.service.v1.AdditionalCardScreenConfigs');
fixType(AdditionalCardScreenConfigs, {
  nextButtonLabel: {
    notEmpty: true
  },
  manualEntryLabel: {
    notEmpty: true
  },
  candidates: {
    required: true
  }
});
Builder.createAndAttachToType(AdditionalCardScreenConfigs);
/**
 * SOURCE Submission @ squareup/bbfrontend/common/workflow/screens/additional_card.proto at 21:3
 */
AdditionalCardScreenConfigs.Submission = $root.lookupType('squareup.bbfrontend.service.v1.AdditionalCardScreenConfigs.Submission');
fixType(AdditionalCardScreenConfigs.Submission, {
  loadingElement: {
    required: true
  }
});
Builder.createAndAttachToType(AdditionalCardScreenConfigs.Submission);
/**
 * SOURCE CardAssignmentCandidate @ squareup/bbfrontend/common/workflow/screens/additional_card.proto at 28:1
 */
export const CardAssignmentCandidate = $root.lookupType('squareup.bbfrontend.service.v1.CardAssignmentCandidate');
fixType(CardAssignmentCandidate);
Builder.createAndAttachToType(CardAssignmentCandidate);
/**
 * SOURCE Owner @ squareup/bbfrontend/common/workflow/screens/additional_card.proto at 34:3
 */
CardAssignmentCandidate.Owner = $root.lookupType('squareup.bbfrontend.service.v1.CardAssignmentCandidate.Owner');
fixType(CardAssignmentCandidate.Owner, {
  fullName: {
    notEmpty: true
  },
  token: {
    notEmpty: true
  },
  profileImage: {
    required: true
  }
});
Builder.createAndAttachToType(CardAssignmentCandidate.Owner);
/**
 * SOURCE ManualEntry @ squareup/bbfrontend/common/workflow/screens/additional_card.proto at 44:3
 */
CardAssignmentCandidate.ManualEntry = $root.lookupType('squareup.bbfrontend.service.v1.CardAssignmentCandidate.ManualEntry');
fixType(CardAssignmentCandidate.ManualEntry);
Builder.createAndAttachToType(CardAssignmentCandidate.ManualEntry);
/**
 * SOURCE ProfileImage @ squareup/bbfrontend/common/workflow/screens/additional_card.proto at 50:3
 */
CardAssignmentCandidate.ProfileImage = $root.lookupType('squareup.bbfrontend.service.v1.CardAssignmentCandidate.ProfileImage');
fixType(CardAssignmentCandidate.ProfileImage);
Builder.createAndAttachToType(CardAssignmentCandidate.ProfileImage);
/**
 * If the person doesn't have an image we want to return initials + text and background color.
 * Designs can be found https://www.figma.com/file/vYX1AHtvVcPaz0HnZ6phoe/%F0%9F%92%B3-Square-Card-(WIP)?node-id=620%3A34969&t=a5dgOyDfqeVDcUGj-0.
 *
 * SOURCE InitialsAvatar @ squareup/bbfrontend/common/workflow/screens/additional_card.proto at 62:3
 */
CardAssignmentCandidate.InitialsAvatar = $root.lookupType('squareup.bbfrontend.service.v1.CardAssignmentCandidate.InitialsAvatar');
fixType(CardAssignmentCandidate.InitialsAvatar, {
  initials: {
    notEmpty: true
  },
  backgroundColor: {
    notEmpty: true
  },
  initialsColor: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CardAssignmentCandidate.InitialsAvatar);